import React from 'react'
import { Row, Col, Typography } from 'antd'
import { GoogleOutlined, CalendarOutlined, MailOutlined } from '@ant-design/icons'

import { useFirebase } from '../firebaseContext'
import { useRedux } from '../redux'

const { Title } = Typography
const currentyear = new Date().getFullYear()

export default function Home() {
  const [subs, setSubs] = React.useState(0)
  const [dates, setDates] = React.useState(0)
  const [messages, setMessages] = React.useState(0)
  const firebase = useFirebase()
  const actions = useRedux()

  React.useEffect(() => {
    //CONTADOR DE SUBSCRIPSIONES
    const ref = firebase.getCollectionRef('users').where('created', '>=', new Date(currentyear, 1, 1))
    const unsuscribe = ref.onSnapshot(async snap => {
      let cont = 0
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(doc => {
        cont++
      }))
      setSubs(cont)
      actions.setAppLoading(false)
    })

    //CONTADOR DE CITAS
    const ref2 = firebase.getCollectionRef('appointments').where('created', '>=', new Date(currentyear, 1, 1))
    const unsuscribe2 = ref2.onSnapshot(async snap => {
      let cont = 0
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(doc => {
        cont++
      }))
      setDates(cont)
      actions.setAppLoading(false)
    })

    //CONTADOR DE MENSAJES
    const ref3 = firebase.getCollectionRef('messages').where('created', '>=', new Date(currentyear, 1, 1))
    const unsuscribe3 = ref3.onSnapshot(async snap => {
      let cont = 0
      actions.setAppLoading(true)
      await Promise.all(snap.docs.map(doc => {
        cont++
      }))
      setMessages(cont)
      actions.setAppLoading(false)
    })

    return () => {
      unsuscribe()
      unsuscribe2()
      unsuscribe3()
    }
  }, [])

  return (
    <div>
      <Title level={2}>Inicio</Title>
      <Row>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <div className="widget">
            <GoogleOutlined className="wicon" />
            <div>
              <h2>Suscripciones</h2>
              <h2>{subs}</h2>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <div className="widget">
            <CalendarOutlined className="wicon" />
            <div>
              <h2>Citas</h2>
              <h2>{dates}</h2>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <div className="widget">
            <MailOutlined className="wicon" />
            <div>
              <h2>Mensajes</h2>
              <h2>{messages}</h2>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
